import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Node3D } from '../../../base/node3d/Component';
import { useGizmoDrawn } from '../../../../r3f/hooks/useGizmoState';
import { RayGizmo } from './RayGizmo';
import { DEFAULT_DEBUG_SHAPE_THICKNESS, DEFAULT_ENABLED, DEFAULT_TARGET_POSITION } from './types';
export function RayCast3D({ node, children }) {
    const props = node.properties;
    const drawsGizmo = useGizmoDrawn('every-node');
    return (_jsxs(Node3D, { node: node, children: [drawsGizmo && (_jsx(RayGizmo, { target: props.target_position ?? DEFAULT_TARGET_POSITION, thickness: props.debug_shape_thickness ?? DEFAULT_DEBUG_SHAPE_THICKNESS, customColor: props.debug_shape_custom_color, enabled: props.enabled ?? DEFAULT_ENABLED })), children] }));
}
//# sourceMappingURL=Component.js.map